export class TokenValid {
     answer: boolean;
     token: string;
}